import NewGetStarted from "./NewGetStarted";

export default NewGetStarted;
